module.exports = __webpack_public_path__ + "img/green-1-oval-solid.e65da77b.svg";